var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"c-app align-items-center",attrs:{"id":"btn_home"}},[_c('div',{staticClass:"d-grid gap-2 mx-auto text-center col-lg-3 col-md-3 col-sm-12 col-xs-12"},[_c('h2',[_vm._v("HOME ASISTENCIAL")])])])])
}]

export { render, staticRenderFns }